/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CheckCircleFill({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#CheckCircleFill_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M8 .4a7.6 7.6 0 1 0 0 15.2A7.6 7.6 0 0 0 8 .4m3.966 5.378a.6.6 0 1 0-.932-.756l-4.101 5.047-1.981-2.264a.6.6 0 0 0-.904.79l2.294 2.622a.8.8 0 0 0 1.223-.023z" clipRule="evenodd" /></g><defs><clipPath id="CheckCircleFill_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;